export default "__VITE_ASSET__Ce0yjTV3__"